import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress'; 
import { Hand } from './Hand';
import { Deck } from './Deck';
import { Program } from './Program';
import { apiFetch } from '../Helpers/api';

let CARD_WIDTH = 150;

export function Developer(props) {

    const [decks, setDecks] = useState([
        {
            codebaseInfo: {},
            cards: []
        }
    ])
    const [discard, setDiscard] = useState([])
    const [codebaseInfo, setCodebaseInfo] = useState()
    const [hand, setHand] = useState([])
    const [programs, setPrograms] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false)
    const [loadError, setLoadError] = useState('')
        
    useEffect(() => {
        apiFetch("codebase.php?codebase_id=" + encodeURIComponent(props.codebaseId))
            .then((res) => res.json())
            .then((json) => {
                if (json.error) {
                    setLoadError(json.error)
                    setDataLoaded(true)
                    return
                }
                setDecks(json.data.decks)
                setCodebaseInfo(json.data.info)
                setDataLoaded(true)
                const programData = []
                json.data.programs.map((program) =>
                    programData.push([[program]])
                )
                setPrograms(programData)
            })
    }, [props.codebaseId]) 

    return (
        <div style={{display: props.inFocus ? 'block' : 'none', width: '100%', float: 'left'}}>
        { dataLoaded && loadError && <div className="auth-error">{loadError}</div> }
        { dataLoaded && !loadError &&
            <>
            <div style={{display: 'block', width: '100%', float: 'left'}}>
                <div className='white-code'>your <b>program(s)</b></div>
                { programs.map((program, index) =>
                    <Program currentHome={'program_' + props.player} programs={programs} programIndex={index} program={program} codebase={codebaseInfo} cardWidth={CARD_WIDTH} setCards={setPrograms} key={index} />
                )}
            </div>
            <div style={{display: 'block', width: '100%', float: 'left'}}>
                <div className='white-code'>your hand and <b>codebase</b></div>
                { decks.map((deck, index) =>
                    <Deck currentHome={'codebase_' + codebaseInfo.codebase_id + props.player} codebase={codebaseInfo} name={deck.length > 0 ? deck[0].deck : codebaseInfo.name} cards={deck} decks={decks} cardWidth={CARD_WIDTH} setCards={setDecks} cardStyle='deck' deckIndex={index} key={index} />
                )}
                    <Hand currentHome={'hand_' + props.player} codebase={codebaseInfo} cards={hand} cardWidth={CARD_WIDTH} setCards={setHand} handType='developer'/> 
                    <Deck currentHome={'discard_' + codebaseInfo.codebase_id + props.player} codebase={codebaseInfo} name='Discard Pile' cards={discard} cardWidth={CARD_WIDTH} setCards={setDiscard} cardStyle='discard' />
            </div>
            </>
        }
        { !(dataLoaded) &&
            <LinearProgress color="success" />
        }
        </div>
    )   
}
